import styled from 'styled-components';

export const PopupContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: min(300px, calc(100vw - 2rem));
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(16, 42, 67, 0.12);
  z-index: 110;
  overflow: hidden;
`;

export const PopupHeader = styled.div`
  padding: 12px 14px;
  background: #F9FAFB;
  border-bottom: 1px solid #E5E7EB;
`;

export const PopupName = styled.div`
  font-weight: 800;
  color: #111827;
  margin-bottom: 2px;
`;

export const PopupEmail = styled.div`
  color: #6B7280;
  font-size: 0.95rem;
`;

export const PopupList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const PopupItem = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  color: #111827;
  cursor: pointer;
  &:hover { background: #F3F4F6; }
`;

export const Divider = styled.div`
  height: 1px;
  background: #E5E7EB;
`;


